import { Input } from '@base-ui/react/input';
import type { ComponentPropsWithRef } from 'react';

import { cn } from '@/lib/utils';

export type TextInputProps = Omit<ComponentPropsWithRef<typeof Input>, 'size'> & {
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  warning?: boolean;
};

const sizeClasses = {
  small: cn('h-6 rounded-sm px-3 text-sm'),
  medium: cn('h-8 rounded-md px-3 text-sm'),
  large: cn('h-10 rounded-md px-3 text-base'),
};

const TextInput = ({ ref, className, size = 'large', warning, ...props }: TextInputProps) => {
  return (
    <Input
      ref={ref}
      data-warning={warning ? '' : undefined}
      className={cn(
        'w-full border border-gray-600 bg-white text-gray-900',
        'placeholder:text-gray-500',
        'hover:border-gray-900',
        'focus:border-green-500 focus:ring-1 focus:ring-green-500/50 focus:ring-offset-0 focus:outline-none',
        'data-warning:border-yellow-400 data-warning:hover:border-yellow-300 data-warning:focus:border-yellow-500 data-warning:focus:ring-yellow-500/50',
        'aria-invalid:border-red-400 aria-invalid:focus:border-red-500 aria-invalid:focus:ring-red-500/50',
        'disabled:cursor-not-allowed disabled:border-gray-400 disabled:bg-gray-100 disabled:text-gray-400',

        sizeClasses[size as keyof typeof sizeClasses],
        className,
      )}
      data-slot="input"
      {...props}
    />
  );
};

TextInput.displayName = 'TextInput';

export default TextInput;
